import { Component, Input } from '@angular/core';
import { FormGroup, FormGroupDirective } from "@angular/forms";
import { DynamicFormModel } from "../../models/dynamic-form-model";


@Component({
  selector: 'ebw-monorepo-dynamic-input',
  templateUrl: './dynamic-input.component.html',
  styleUrls: ['./dynamic-input.component.scss'],
})
export class DynamicInputComponent {
  @Input() field: DynamicFormModel;
  formName: FormGroup;

  constructor(private formgroupDirective: FormGroupDirective) {
    this.formName = formgroupDirective.control
  }
}
